<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .title -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('master.title')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  vid="title"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.title"
                    type="text"
                    :placeholder="$t('master.title')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .unique_code -->

            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                label="خلال الفترة الزمنية"
                label-for="input-2"
              >
                <flat-pickr
                  v-model="rangeDate"
                  class="form-control"
                  :config="config"
                />
              </b-form-group>
              <!-- .end_date -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MasterSemenarController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
var dates = [];

export default {
  name: "MasterSemenarForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
   "flat-pickr": flatPickr,
  },
  data() {
    return {
      file: {},
      online_class: [],
      rangeDate: "",
      config: {
        mode: "range",
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: Arabic,

        onChange: function (date) {
          if (date.length == 2) {
            dates = date;
            // interact with selected dates here
          }
        },
      },
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.start_date = dates[0]
        .toJSON()
        .slice(0, 19)
        .replace("T", " ");
      this.newItem.end_date = dates[1].toJSON().slice(0, 19).replace("T", " ");
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
  
